export const encryptionKeys = {
  IV: '',
  key: ''
};

export interface keyValuePair {
  key: string;
  value: number;
}

export const OtpType = {
  SignUp: 1,
  Login: 2,
  Forgot: 3
};

export const ModuleConst = {
  Dashboard: 1,
  AnalyticsReports: 2,
  Subscribers: 3,
  SubscriptionPlans: 4,
  Payment: 5,
  Support: 6,
  SubAdmin: 7
};

export const SupportConst = {
  Lists: `${ModuleConst.Support}01`,
  Tickets: `${ModuleConst.Support}02`
};

export const TicketStatus = {
  Open: 1,
  Closed: 2
};

export const userRole = {
  ADMIN: 7,
  SUBADMIN: 8
};

export const SUBSCRIPTION_TYPE = {
  FREE: 1,
  PAID: 2,
  FREE_TRIAL: 3
};

export const pricingPlanType: Array<keyValuePair> = [
  {
    key: 'MONTHLY',
    value: 1
  },
  {
    key: 'Annually',
    value: 2
  }
];

export const priceTypeConst = {
  UserPrice: 1,
  PackagePrice: 2
};

export const priceType: Array<keyValuePair> = [
  {
    key: 'UserPrice',
    value: priceTypeConst.UserPrice
  },
  {
    key: 'PackagePrice',
    value: priceTypeConst.PackagePrice
  }
];

export const noData = {
  noData: '---'
};

export const businessSize = [
  {
    key: 'SMALL',
    value: 1
  },
  {
    key: 'MEDIUM',
    value: 2
  },
  {
    key: 'LARGE',
    value: 3
  }
];

export const INSTITUTION_TYPE = [
  {
    key: 'SCHOOL',
    value: 1
  },
  {
    key: 'UNIVERSITY',
    value: 2
  },
  {
    key: 'ED_TECH',
    value: 3
  },
  {
    key: 'OTHERS',
    value: 4
  }
];

export const Subscribers_Status = [
  {
    key: 'Active',
    value: 1,
    color: 'c_success' // Added missing color
  },
  // {
  //   key: 'Not Active',
  //   value: 0,
  //   color: 'c_danger'
  // },
  {
    key: 'Inactive',
    value: 2,
    color: 'c_danger'
  },
  {
    key: 'Free Trial',
    value: 3,
    color: 'c_warning'
  },
  {
    key: 'Cancelled',
    value: 4,
    color: 'c_danger'
  }
];

export const subscriberGraphColor = {
  pendingCount: '#0a9e59',
  activeCount: '#feb600',
  inactiveCount: '#bc5c21',
  freeTrialCount: '#219ebc',
  cancelCount: '#ff0000'
};

export const subscriberPercentageColor = {
  paidSubscriptions : '#0a9e59',
  freeSubcriptions : '#bc5c21'
};

export const supportChatColor = {
  pendingCount:'#feb600',
  closedCount:'#bc5c21'
};

export const majorRoles = {
  ADMIN: 1,
  STUDENT: 2,
  TUTOR: 3,
  COUNSELOR: 4,
  PARENT: 5,
  SUBADMIN: 6,
  INSTRUCTOR: 9
};

export const sessionConst = {
  scheduled:1,
  completed:3
};

export const paymentMethodConst = [
  {
    key : 'Card',
    value: 1
  },
  {
    key : 'Bank',
    value: 2
  },
  {
    key : 'Transfer',
    value: 3
  },
  {
    key : 'Cash',
    value: 4
  }
];

export const paymentMethod = {
  Card:1,
  Bank:2,
  Transfer:3,
  Cash:4
};

// export const paymentStatus = [
//   {
//     key:'Pending',
//     value:'1'
//   },
//   {
//     key:'Paid',
//     value:'2'
//   },
//   {
//     key:'Void',
//     value:'3'
//   },
//   {
//     key:'Declined',
//     value:'4'
//   }
// ];

export const paymentStatus = [
  {
    key: 'Pending',
    value: '1',
    color: 'c_warning' // Added missing color
  },
  {
    key: 'Paid',
    value: '2',
    color: 'c_success'
  },
  {
    key: 'Void',
    value: '3',
    color: 'c_danger'
  },
  {
    key: 'Declined',
    value: '4',
    color: 'c_danger'
  }
];

export const paymentStatusConst = {
  Paid:1,
  Declined:2,
  Refunded:3,
  Void:4
};

export const EditViewTypeConst = {
  General: 'general',
  Documents: 'documents'
};